function setupModalFocus(modal, uuidType, targetSelector) {
  const uuidKey = `current-${uuidType}-uuid`;
  const uuidDatasetKey = `${uuidType}Uuid`;
  const uuidDataSelector = (id) => `[data-${uuidType}-uuid="${id}"]`;

  modal.addEventListener('shown.bs.modal', (e) => {
    window[uuidKey] = e.relatedTarget.dataset[uuidDatasetKey];
  });

  modal.addEventListener('hidden.bs.modal', () => {
    const currentId = window[uuidKey];
    window[uuidKey] = null;

    if (!currentId) {
      return;
    }

    const row = document.querySelector(uuidDataSelector(currentId));
    const targetElement = row.querySelector(targetSelector);

    targetElement.focus();
  });
}

window.setupModalFocus = setupModalFocus;

export default setupModalFocus;
